import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import { useNavigate, useParams } from "react-router-dom";
import { UiSelect, UiInput, OverlayLoader, UiButton, titleCase, UiToggle, UiClientSelect } from "../ui";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStore } from "../state.js";
import { notification } from "antd";
import { setStorage, getStorage } from "../helper.js";


const Account = NiceModal.create(
  ({ title, subtitle, action, bgColor, note = "", data }) => {
    const [input, setInput] = useState(note);
    const [state, setState] = useState({ count: 0 });
    const [entry, setEntry] = useState([]);
    const modal = useModal();
    const categories = useStore((state) => state.categories);
    const states = useStore((state) => state.states);
    const schema = yup.object().shape({
      name: yup.string().required("Enter name of account"),
      category: yup.string().required("Select group"),
      notification: yup.bool(),
      mobile: yup.string().nullable().when('mobile', {
        is: (value) => value?.length,
        then: (rule) => rule.matches(/^[0-9]+$/, "Enter 10 digit mobile number")
          .min(10, "Enter 10 digit mobile number")
          .max(10, "Enter 10 digit mobile number"),
      }),

      mobile2: yup.string().nullable().when('mobile2', {
        is: (value) => value?.length,
        then: (rule) => rule.matches(/^[0-9]+$/, "Enter 10 digit mobile number")
          .min(10, "Enter 10 digit mobile number")
          .max(10, "Enter 10 digit mobile number"),
      }),

      opening_balance: yup.string().nullable().when('opening_balance', {
        is: (value) => value?.length,
        then: (rule) => rule
          .matches(/^[0-9.]+$/, "Enter opening balance amount")
          .min(0, 'Negative value not allowed')

      }),

      credit_limit: yup.string().nullable().when('credit_limit', {
        is: (value) => value?.length,
        then: (rule) => rule
          .matches(/^[0-9.]+$/, "Enter credit limit amount")
          .min(0, 'Negative value not allowed')

      }),
      gstin: yup.string().nullable()
        .when("gstin", {
          is: (value) => value?.length,
          then: (rule) =>
            rule
              .matches(
                /^[0-9]{2}[0-9A-Za-z]{13}$/,
                "Enter valid GST number"
              )
              .required("Enter GST number"),
        }),

      opening_balance_type: yup.string().nullable().when('opening_balance', {
        is: (value) => value?.length,
        then: (rule) => rule
          .required("Select opening balance type")

      }),

    }, [['opening_balance', 'opening_balance'], ['mobile', 'mobile'], ['mobile2', 'mobile2'], ['credit_limit', 'credit_limit'], ['gstin', 'gstin']]);
    const {
      register,
      handleSubmit,
      control,
      watch,
      unregister,
      setValue,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      setState({ ...state, loader: true });

      instance({
        method: "post",
        url: "/update_account",
        data: e,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            useStore.setState({ load_accounts: false });
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };
    useEffect(() => {

      if (data) {
        //)
        reset(data)

      } else {
        setValue('state', getStorage('state'))
      }


    }, [data]);


    const watchGroup = watch("category");

    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Account</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          <form id="accountform" onSubmit={handleSubmit(onSubmitHandler)}>

            <UiInput
              label="Name"
              type="text"
              required
              name="name"
              {...register("name", { onBlur: (e) => setValue('name', titleCase(e.target.value)) })}
              message={errors.name?.message}
            />

<UiToggle
                  id="status"
                  name="status"
                  value="1"
                  title="Is Active?"
                  {...register("status")}
                />


            <UiSelect
              name='category'
              required
              label="Group"
              message={errors.category?.message}
              options={categories}
              {...register(`category`)}
            />

            {(watchGroup == '1' || watchGroup == '2' || watchGroup == '26') && (
              <>
                <div className="row">
                  <div className="col-8">
                    <UiInput
                      label="Address"
                      type="text"
                      name="address"
                      {...register("address", { onBlur: (e) => setValue('address', titleCase(e.target.value)) })}
                      message={errors.address?.message}
                    />

                  </div>
                  <div className="col-4">
                    <UiInput
                      label="City"
                      type="text"
                      name="city"
                      {...register("city", { onBlur: (e) => setValue('city', titleCase(e.target.value)) })}
                      message={errors.city?.message}
                    />

                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <UiInput
                      label="Contact Person"
                      type="text"
                      name="contact_person"
                      {...register("contact_person", { onBlur: (e) => setValue('contact_person', titleCase(e.target.value)) })}
                      message={errors.contact_person?.message}
                    />
                  </div>
                  <div className="col-6">
                    <UiInput
                      label="Mobile No."
                      type="text"
                      name="mobile"
                      {...register("mobile")}
                      message={errors.mobile?.message}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <UiInput
                      label="Contact Person 2"
                      type="text"
                      name="contact_person2"
                      {...register("contact_person2", { onBlur: (e) => setValue('contact_person2', titleCase(e.target.value)) })}
                      message={errors.contact_person2?.message}
                    />
                  </div>
                  <div className="col-6">
                    <UiInput
                      label="Mobile No. 2"
                      type="text"
                      name="mobile2"
                      {...register("mobile2")}
                      message={errors.mobile2?.message}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-6">
                    <UiInput
                      label="GSTIN"
                      type="text"
                      name="gstin"
                      {...register("gstin")}
                      message={errors.gstin?.message}
                    />
                  </div>
                  <div className="col-6">
                    <UiSelect
                      name='state'
                      label="State"
                      message={errors.state?.message}
                      options={states}
                      {...register(`state`, { onChange: (e) => setStorage('state', e.target.value) })}
                    />
                  </div>
                </div>

                <UiToggle
                  id="notification"
                  name="notification"
                  value="1"
                  title="Enable Notifications"
                  {...register("notification")}
                />

                


              </>
            )}

            {watchGroup == '2' && (
              <>
                <UiInput
                  label="Credit Limit"
                  type="text"
                  name="credit_limit"
                  {...register("credit_limit")}
                  message={errors.credit_limit?.message}
                />
              </>
            )}
            <h5>Opening Balance</h5>
            <div className="row">
              <div className="col-8">
                <UiInput
                  label="Amount"
                  type="text"
                  name="opening_balance"
                  {...register("opening_balance")}
                  message={errors.opening_balance?.message}
                />
              </div>
              <div className="col-4">
                <UiSelect
                  name='opening_balance_type'
                  label="Type"
                  message={errors.opening_balance_type?.message}
                  //defaultValue={value.machine}
                  options={["Dr", "Cr"]}
                  {...register(`opening_balance_type`)}
                />
              </div>
            </div>





            <Controller
              name={`staff`}
              control={control}
              render={({ field }) => (

                <UiClientSelect
                  {...field}

                  parentClass="mb-1"
                  category={[26]}
                  className=""
                  fetch_onload
                  message={errors.staff?.message}
                  label="Staff"
                />

              )}
            />





            {data && (<input type="hidden" value={data.id} name="id" {...register("id")} />)}
            <UiButton className="btn btn-primary mt-4" type="submit" title="Save" />

          </form>
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default Account;
